<div
  class="card ejemplo-card mb-1"
  [ngStyle]="{ 'margin-left': '0.' + nivel * 1 + 'rem' }">
  <!-- Encabezado: Actor + acciones de actualizar/eliminar -->
  <div
    class="card-header header-box text-black d-flex justify-content-between align-items-center">
    <div class="d-flex align-items-center">
      <span>{{ ejemplo.actor }}</span>
    </div>
    <div>
      <button
        type="button"
        *ngIf="!isReadOnly"
        class="btn btn-sm btn-outline-primary me-2 option-box"
        (click)="onActualizar()">
        Actualizar
      </button>
      <button
        type="button"
        *ngIf="!isReadOnly"
        class="btn btn-sm btn-outline-primary option-box"
        (click)="onEliminar()">
        Eliminar
      </button>
    </div>
  </div>
  <!-- Cuerpo: Texto del ejemplo -->
  <div class="card-body">
    <p class="card-text">{{ ejemplo.texto }}</p>
  </div>
</div>
